__turbopack_context__.v({
  "newsletter-unsubscribe": "mP5tzG_newsletter-unsubscribe",
  "newsletter-unsubscribe__form": "mP5tzG_newsletter-unsubscribe__form",
});
